<app-local-loading-indicator *ngIf="statusSvc.isLoading$ | async" width="90%" height="100%" applyOverlay="true">
</app-local-loading-indicator>
<div class="row">
    <div class="col-md-12 mt-2">
        <emr-checkboxlist identifier="shipments-filter-status" name="shipments-filter-status" [(ngModel)]="filter"
            [options]="statusList" [inline]=true optionsTextField="Description" optionsValueField="TripStateCode"
            (onChange)="isDirty = true" textCssClass="align-baseline" returnType="array">
        </emr-checkboxlist>
    </div>
</div>